import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=4941783b"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
import style0 from "./Overview.vue?vue&type=style&index=0&id=4941783b&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4941783b')) {
      api.createRecord('4941783b', component.options)
    } else {
      api.reload('4941783b', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=4941783b", function () {
      api.rerender('4941783b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/dashboard_content/Overview.vue"
export default component.exports